import { memo, ComponentType } from 'react';
import { flowRight } from 'lodash';
import { withProvider } from './withProvider';

type ProviderDefinition<P = any> = {
  Provider: ComponentType<P>;
  providerProps?: Omit<ComponentType<P>, 'children'>;
};

export function withProviders<T = any>(
  Component: ComponentType<T>,
  ...providers: Array<ProviderDefinition>
): ComponentType<T> {
  const withProviderCalls = providers.map(({ Provider, providerProps }) =>
    withProvider(Provider, providerProps),
  );
  return flowRight(...withProviderCalls, memo)(Component) as ComponentType<T>;
}

export function withStoreProviders<T = any>(
  Component: ComponentType<T>,
  ...providers: Array<ComponentType>
): ComponentType<T> {
  const providerDefinitions = providers.map(Provider => ({ Provider }));
  return withProviders(Component, ...providerDefinitions);
}
